export enum SystemViewTypes {
	Admin = "admin",
	Viewer = "viewer",
	External = "external",
	Testing = "testing",
}
